import keyWrapper from '~publish/helpers/keywrapper'

export const actionTypes = keyWrapper('PROFILES', {
  FETCH_SINGLE_PROFILE: 0,
})

export const actions = {
  fetchSingleProfile: ({
    profileId,
    message,
  }: {
    profileId: string | undefined
    message?: string
  }): {
    type: typeof actionTypes.FETCH_SINGLE_PROFILE
    profileId: string | undefined
    message?: string
  } => ({
    type: actionTypes.FETCH_SINGLE_PROFILE,
    profileId,
    message,
  }),
}
